import React from 'react';
import PropTypes from 'prop-types';

import './progress.scss';

const Progress = (props) => {
	const { active, delay, speed } = props;

	return (
		<span className={`slider-progress${active ? ' is-active' : ''}`}>
			<span
				className="slider-progress__track"
				style={{
					WebkitAnimationDelay: `${active ? delay : 0}ms`,
					animationDelay: `${active ? delay : 0}ms`,
					WebkitAnimationDuration: `${active ? speed : 0}ms`,
					animationDuration: `${active ? speed : 0}ms`,
				}}
			/>
		</span>
	);
};

Progress.defaultProps = {
	active: false,
	delay: 0,
	speed: 3000,
};

Progress.propTypes = {
	active: PropTypes.bool,
	delay: PropTypes.number,
	speed: PropTypes.number,
};

export default Progress;
